import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { usePopup } from "../context/PopupContext";
let logoutTimeout = null;
const LogoutCount = 5;
const AuthDropdown = ({ closeNavbarMenu }) => {
  const { showPopup } = usePopup();

  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  

  // Handle window resize to update mobile state
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Close dropdown ONLY when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsLoginOpen(false); // Collapse menu only if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogoutClick = () => {
    if (logoutTimeout) {
        clearTimeout(logoutTimeout);
    }

    // console.log("Initial logoutCountdownActive:", localStorage.getItem("logoutCountdownActive"));

    localStorage.setItem("logoutCountdownActive", "true");
    
    // console.log("After setting to 'true', logoutCountdownActive:", localStorage.getItem("logoutCountdownActive"));
    // console.log("logout handle activated");

    logoutTimeout = setTimeout(() => {
        // console.log("Before condition check, logoutCountdownActive:", localStorage.getItem("logoutCountdownActive"));

        if (localStorage.getItem("logoutCountdownActive") === "true") {
            console.log(" Logout executed");
            // localStorage.removeItem("logoutCountdownActive"); // ✅ Remove flag AFTER confirming logout
            logout();
        } else {
            console.log("❌ Logout was canceled before execution.");
        }
    }, LogoutCount * 1000);

    showPopup(`Logging out in ${LogoutCount} seconds...`, "logout", {
        countdown: LogoutCount,
        onClose: () => {
            console.log("🚫 Popup closed, checking logoutCountdownActive:", localStorage.getItem("logoutCountdownActive"));

            // ✅ Only cancel if `logoutCountdownActive` is still present (means user manually closed)
            if (localStorage.getItem("logoutCountdownActive") === "true") {
                console.log("🚫 User manually canceled logout.");
                clearTimeout(logoutTimeout);
                logoutTimeout = null;
                localStorage.removeItem("logoutCountdownActive"); 
            } else {
                console.log("✅ Popup closed after countdown ended, logout proceeds.");
            }
        }
    });
};




  
  
  return (
    <div className="relative auth-dropdown-container" ref={dropdownRef}>
      {/* 🔹 Login Button - Theme aware */}
      <span
        onClick={() => setIsLoginOpen(!isLoginOpen)}
        className={`cursor-pointer transition ${
          isMobile
            ? 'text-base' // Mobile uses theme colors
            : 'text-sm' // Desktop uses theme colors
        } hover:text-blue-500`}
        style={{
          color: 'var(--text-primary)',
          // match the nav-link-modern pill padding so the username/Login isn't
          // jammed against the pill border (desktop pill parity with Astro nav)
          padding: isMobile ? '0' : '0.45rem 0.95rem',
          borderRadius: '999px',
          display: 'inline-block',
          lineHeight: 1,
          whiteSpace: 'nowrap'
        }}
      >
        {user ? user.name : "Login"}
      </span>

      {/* 🔹 Dropdown Menu (Only Closes When Clicking Outside) */}
      {isLoginOpen && (
        <div
          className="absolute top-full mt-2 w-56 rounded-2xl p-4 auth-dropdown-menu backdrop-blur-md transition-all duration-300
            md:right-0 md:left-auto md:translate-x-0
            left-1/2 transform -translate-x-1/2"
          style={{
            boxShadow: '0 14px 44px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.32)'
          }}
        >
          {!user ? (
            <>
              <h3 className="text-md font-bold mb-2" style={{ color: 'var(--text-primary)' }}>Sign In</h3>
              <p className="text-sm mb-4" style={{ color: 'var(--text-secondary)' }}>
                Sign in to access your profile and personalized features.
              </p>
              <Link
                to="/login"
                className="btn-3d block text-center py-2 px-4 rounded-xl"
                onClick={() => {
                  setIsLoginOpen(false); // ✅ Collapse dropdown after click
                  closeNavbarMenu();
                  navigate("/login");   // ✅ Navigate properly
                }}
              >
                Login
              </Link>
              <p className="text-sm text-center mt-2" style={{ color: 'var(--text-secondary)' }}>
                New to our platform?
              </p>
              <Link
                to="/register"
                className="block text-center text-blue-500 hover:underline mt-1"
                onClick={() => {
                  setIsLoginOpen(false); // ✅ Collapse dropdown after click
                  closeNavbarMenu();
                  navigate("/register"); // ✅ Navigate properly
                }}
              >
                Create an account
              </Link>
            </>
          ) : (
            <>
              <Link to="/account"
              className="btn-3d block text-center py-2 px-4 mb-2 text-sm rounded-full"
              onClick={() => setIsLoginOpen(false)}
              >
                Account
              </Link>
              <Link to="/dashboard"
              className="btn-3d block text-center py-2 px-4 mb-2 text-sm rounded-full"
              onClick={() => setIsLoginOpen(false)}
              >
                My Dashboard
              </Link>
              <Link to="/orders"
              className="btn-3d block text-center py-2 px-4 mb-2 text-sm rounded-full"
              onClick={() => setIsLoginOpen(false)}
              >
                Orders
              </Link>
              <button
                onClick={() => {
                  setIsLoginOpen(false); // ✅ Close dropdown
                  handleLogoutClick(); // ✅ Restore logout countdown
                }}
                className="btn-3d block w-full text-center py-2 px-4 text-sm rounded-full"
              >
                Logout
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default AuthDropdown;